import React from 'react';

import { useTranslation } from 'react-i18next';

import Tooltip from '../../../../Tooltip';

import classes from './styles.module.scss';

export default function CandidateSourceTag({ sourceType }) {
  const { t } = useTranslation();
  console.log('sourceType', sourceType);
  let sourceText;

  sourceText = '';

  switch (sourceType) {
    case 'External':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Sourced'
      );
      break;
    case 'Agency':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Agency'
      );
      break;
    case 'Direct':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Direct'
      );
      break;
    case 'Web':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Direct'
      );
      break;
    case 'Direct Application':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Direct Application'
      );
      break;
    case 'Direct Email':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Direct Email'
      );
      break;
    case 'Internal Referral':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Internal Referral'
      );
      break;
    case 'External Referral':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.External Referral'
      );
      break;
    case 'External Source':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.External Source'
      );
      break;
    case 'Agency Submission':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Agency Submission'
      );
      break;
    case 'Career Page':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Career Page'
      );
      break;
    case 'Campus / College':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Campus / College'
      );
      break;
    case 'Talent Pool':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Talent Pool'
      );
      break;
    case 'Other':
      sourceText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Other'
      );
      break;
    default:
      sourceText = '';
      break;
  }

  let tooltipText;

  tooltipText = '';

  switch (sourceType) {
    case 'Direct Application':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.DirectTooltip'
      );
      break;
    case 'Direct Email':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Direct EmailTooltip'
      );
      break;
    case 'Internal Referral':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Internal ReferralTooltip'
      );
      break;
    case 'External Referral':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.External ReferralTooltip'
      );
      break;
    case 'External Source':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.External SourceTooltip'
      );
      break;
    case 'Agency Submission':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Agency SubmissionTooltip'
      );
      break;
    case 'Career Page':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Career PageTooltip'
      );
      break;
    case 'Campus / College':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Campus / CollegeTooltip'
      );
      break;
    case 'Talent Pool':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.Talent PoolTooltip'
      );
      break;
    default:
      tooltipText = '';
      break;
    case 'Other':
      tooltipText = t(
        'dashboardComponents.Candidate.CandidateHeader.sources.OtherTooltip'
      );
      break;
  }

  return (
    <Tooltip text={tooltipText} noWrap>
      <div className={classes.CandidateSourceTag}>{sourceText}</div>
    </Tooltip>
  );
}
